<template>
    <div class="forum-loader-after">
        <hr class="hr-66">
        <hr class="hr-33">
        <Loader></Loader>
    </div>
</template>

<script>
    // ForumLoaderAfter: a loading animation stylized for the forum to indicate
    // that something is loading after the previous set of results.

    import Loader from './loader';

    export default {
        components: {
            Loader,
        },
    }
</script>

<style lang="scss" scoped>
    hr {
        border-color: #333;
        margin: 20px auto;
    }
    .hr-33 {
        opacity: 0.4;
        width: calc(100% - 40px);
    }
    .hr-66 {
        opacity: 0.66;
        width: calc(100% - 20px);
    }
</style>



// WEBPACK FOOTER //
// loader-after.vue?1c9fcb6b